import React from "react";
import { FaqItemData } from "@/data/faq.data";
import styles from "@/components/pages/convert/components/styles/convert-faq.module.scss";
import FaqItem from "@/components/common/faq-item";

const SplitterFaq = () => {
  const data = [
    {
      question: `File upload guide`,
      answer: `1. Upload a full track.\n
      2. Preview and download individual stems.`,
    },
  ] as FaqItemData[];

  return (
    <div className={styles.convert_faq_wrapper}>
      {data.map((item, index) => (
        <FaqItem key={index} data={item} />
      ))}
    </div>
  );
};

export default SplitterFaq;
